import script from "./SelectionManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectionManager.vue?vue&type=script&setup=true&lang=ts"

import "./SelectionManager.vue?vue&type=style&index=0&id=4432d6df&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4432d6df"]])

export default __exports__